import { createReducer } from "redux-create-reducer";
import { PROFILE_ACTIONS } from "./profileActions";
import { MISC_PROFILE_ACTIONS } from "../misc/miscActions";
import { AUTH_ACTIONS } from "../auth/authActions";
import { REHYDRATE } from "redux-persist/constants";
import { PAYMENT_ACTIONS } from "../payment/paymentActions";
import { VALIDATION_ACTIONS } from "../validation/validationActions";
import { backToFront } from "./dataConversion";
import { ACCTS_ACTIONS } from "../accts/acctsActions";
const VERSION = 5;
const INITIAL_STATE = {
    version: VERSION,
    isLoading: false,
    error: null,
    isSuccess: null,
    fieldErrors: [],
    isDeletingBankAccount: false,
    deleteBankAccountError: null
};
/**
 * Reducer creation and export.
 * Uses the constants above to define new state for each action
 */
export default createReducer(INITIAL_STATE, {
    [REHYDRATE](state, action) {
        const { profile } = action.payload;
        if (profile && profile.version === VERSION) {
            return {
                ...state,
                profile: profile.profile
            };
        }
        return { ...state };
    },
    /* --- Profile Create --- */
    [PROFILE_ACTIONS.PROFILE_CREATE_STARTED](state, _action) {
        return {
            ...state,
            isLoading: true,
            error: null,
            fieldErrors: []
        };
    },
    [PROFILE_ACTIONS.PROFILE_CREATE_FAILED](state, action) {
        return {
            ...state,
            isLoading: false,
            error: action.payload
        };
    },
    [PROFILE_ACTIONS.PROFILE_CREATE_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            isLoading: false,
            fieldErrors: action.payload,
            isSuccess: false
        };
    },
    /* --- Profile Update --- */
    [PROFILE_ACTIONS.PROFILE_CREATE_SUCCEEDED_TRUE](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: true,
            profile: action.payload
        };
    },
    [VALIDATION_ACTIONS.REGISTRATION_COMPLETE](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: true,
            profile: backToFront(action.payload.profile)
        };
    },
    [PROFILE_ACTIONS.PROFILE_UPDATE_STARTED](state, _action) {
        return {
            ...state,
            isLoading: true,
            error: null,
            fieldErrors: []
        };
    },
    [PROFILE_ACTIONS.PROFILE_UPDATE_FAILED](state, action) {
        return {
            ...state,
            isLoading: false,
            error: action.payload
        };
    },
    [PROFILE_ACTIONS.PROFILE_UPDATE_SUCCEEDED_FALSE](state, action) {
        return {
            ...state,
            isLoading: false,
            fieldErrors: action.payload,
            isSuccess: false
        };
    },
    [PROFILE_ACTIONS.PROFILE_UPDATE_SUCCEEDED_TRUE](state, action) {
        const nProfile = {
            ...state.profile,
            ...action.payload.profile
        };
        return {
            ...state,
            isLoading: false,
            isSuccess: true,
            profile: nProfile
        };
    },
    /* --- Profile Fetch --- */
    [PROFILE_ACTIONS.PROFILE_RETRIEVED](state, action) {
        return {
            ...state,
            isLoading: false,
            isSuccess: null,
            profile: action.payload
        };
    },
    /* --- Reset Status Messages --- */
    [MISC_PROFILE_ACTIONS.RESET_MESSAGES](state, _action) {
        return {
            ...state,
            error: null,
            isSuccess: null,
            isLoading: false,
            fieldErrors: []
        };
    },
    [AUTH_ACTIONS.LOGOUT](_state, _action) {
        return INITIAL_STATE;
    },
    [PAYMENT_ACTIONS.PAYMENT_CREATE_SUCCEEDED_TRUE](state, { payload }) {
        const { profile } = state;
        if (payload.data.bankInfo != null) {
            return {
                ...state,
                profile: {
                    ...profile,
                    bankAccounts: [
                        ...profile.bankAccounts,
                        payload.data.bankInfo
                    ]
                }
            };
        }
        return state;
    },
    [PROFILE_ACTIONS.DELETE_BANK_STARTED](state, _action) {
        return {
            ...state,
            isDeletingBankAccount: true,
            deleteBankAccountError: null
        };
    },
    [PROFILE_ACTIONS.DELETE_BANK_SUCCEEDED](state, { payload }) {
        return {
            ...state,
            profile: {
                ...state.profile,
                bankAccounts: state.profile.bankAccounts.filter(it => it.id !== payload)
            },
            isDeletingBankAccount: false
        };
    },
    [PROFILE_ACTIONS.DELETE_BANK_FAILED](state, { payload }) {
        return {
            ...state,
            isDeletingBankAccount: false,
            deleteBankAccountError: payload
        };
    },
    [ACCTS_ACTIONS.EMAIL_OPT_OUT_SUCCEEDED_TRUE](state, { payload }) {
        if (process.env.CLIENT === "CapOne" || state.profile == null || payload.refNums == null) {
            return state;
        }
        const okEmail = payload.refNums.length === 0 ? "yes" : "no";
        return {
            ...state,
            profile: {
                ...state.profile,
                okEmail
            }
        };
    }
});



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/profile/profileReducer.ts